import React from 'react';

const listItemStyle = {
  listStyle: 'none'
};

function ListItem({
  children,
  bulletImageStyle,
  bulletImage,
  listItemAdditionalStyle
}) {
  const BulletImageComponent = bulletImage;

  return (
    <li css={[bulletImage ? listItemStyle : null, listItemAdditionalStyle]}>
      {bulletImage && (
        <BulletImageComponent css={bulletImageStyle} title='bullet' />
      )}
      {children}
    </li>
  );
}

function List({
  listItems,
  listItemImage,
  listItemImageStyle,
  listItemAdditionalStyle = {},
  listStyle = {}
}) {
  return (
    <ul css={listStyle}>
      {listItems.map((listItem) => (
        <ListItem
          key={listItem}
          bulletImage={listItemImage}
          bulletImageStyle={listItemImageStyle}
          listItemAdditionalStyle={listItemAdditionalStyle}
        >
          {listItem}
        </ListItem>
      ))}
    </ul>
  );
}

export default List;
